import { DemoPresentationContent } from 'app/demos/presentation/class/demo-presentation-content';
import { DemoPathAccess } from 'app/demos/presentation/class/demo-path-access';
import { DEMO_ROLES } from 'app/demos/role.constants';
import { PollutingEmissionsDemoGroupType } from 'app/demos/presentation/pollutingEmissions-presentation/pollutingEmissions-demo-group-type';
import { PresentationContentOptions } from 'app/demos/presentation/class/presentation-content-options';
import { DemoName } from '../../demo-name';

// Demonstration groups
export const PollutingEmissionsGroups: PollutingEmissionsDemoGroupType[] = [PollutingEmissionsDemoGroupType.FIRSTGROUP, PollutingEmissionsDemoGroupType.SECONDGROUP];

// Demos for each presentation group - all demo information must be provided below
export const PollutingEmissionsDemoGroups: Map<PollutingEmissionsDemoGroupType, DemoName[]> = new Map<PollutingEmissionsDemoGroupType, DemoName[]>()
    .set(PollutingEmissionsDemoGroupType.FIRSTGROUP, [DemoName.REALEHOMEPAGE_1, DemoName.XDASHREALE_1, DemoName.REALE_1])
    .set(PollutingEmissionsDemoGroupType.SECONDGROUP, [DemoName.MTESHOMEPAGE_1, DemoName.EMISSIONFACTORS, DemoName.CONCAWE_1, DemoName.CONCAWE_2]);

// Content for the header presentation, at the tof of the page
// Presentation images are in content/images/demos/presentation/
export const PollutingEmissionsPresentationTitle = new DemoPresentationContent(
    'presentation.pollutingEmissions.intro.first.title',
    'presentation.pollutingEmissions.intro.first.description',
    'top-bg',
);

// Content for the global presentation description (second section)
// Providing a DemoPathAccess as 4th arg will display a "show more" button, if specified authorities match
export const PollutingEmissionsPresentationDescription: DemoPresentationContent[] = [
    new DemoPresentationContent(
        'presentation.pollutingEmissions.intro.second.title',
        'presentation.pollutingEmissions.intro.second.description',
        'top-img1',
    )
];

// Group level content (presentation of the demonstration group)
export const PollutingEmissionsDemoGroupContents: Map<PollutingEmissionsDemoGroupType, DemoPresentationContent> = new Map<PollutingEmissionsDemoGroupType, DemoPresentationContent>()
    .set(PollutingEmissionsDemoGroupType.FIRSTGROUP, new DemoPresentationContent(
        'presentation.pollutingEmissions.firstGroup.intro.title',
        'presentation.pollutingEmissions.firstGroup.intro.description',
        'firstGroup-desc',
    ))
    .set(PollutingEmissionsDemoGroupType.SECONDGROUP, new DemoPresentationContent(
        'presentation.pollutingEmissions.secondGroup.intro.title',
        'presentation.pollutingEmissions.secondGroup.intro.description',
        'secondGroup-desc',
    ));

// Demo level content (presentation of the demonstration)
// Providing a DemoPathAccess as 4th arg will display a "show more" button, if specified authorities match
export const PollutingEmissionsPresentationContents: Map<DemoName, DemoPresentationContent> = new Map()
    .set(DemoName.REALEHOMEPAGE_1, new DemoPresentationContent(
        'presentation.pollutingEmissions.firstGroup.demo.demo1.title',
        'presentation.pollutingEmissions.firstGroup.demo.demo1.description',
        'firstGroup-demo1',
        null,
        new PresentationContentOptions(false),
    ))
    .set(DemoName.XDASHREALE_1, new DemoPresentationContent(
        'presentation.pollutingEmissions.firstGroup.demo.demo2.title',
        'presentation.pollutingEmissions.firstGroup.demo.demo2.description',
        'firstGroup-demo2',
        null,
        new PresentationContentOptions(true),
    ))
    .set(DemoName.REALE_1, new DemoPresentationContent(
        'presentation.pollutingEmissions.firstGroup.demo.demo3.title',
        'presentation.pollutingEmissions.firstGroup.demo.demo3.description',
        'firstGroup-demo3',
        null,
        new PresentationContentOptions(false),
    ))
    .set(DemoName.MTESHOMEPAGE_1, new DemoPresentationContent(
        'presentation.pollutingEmissions.secondGroup.demo.demo1.title',
        'presentation.pollutingEmissions.secondGroup.demo.demo1.description',
        'secondGroup-demo1',
        null,
        new PresentationContentOptions(false),
    ))
    .set(DemoName.EMISSIONFACTORS, new DemoPresentationContent(
        'presentation.pollutingEmissions.secondGroup.demo.demo2.title',
        'presentation.pollutingEmissions.secondGroup.demo.demo2.description',
        'secondGroup-demo2',
        null,
        new PresentationContentOptions(false),
    ))
    .set(DemoName.CONCAWE_1, new DemoPresentationContent(
        'presentation.pollutingEmissions.secondGroup.demo.demo3.title',
        'presentation.pollutingEmissions.secondGroup.demo.demo3.description',
        'secondGroup-demo3',
        null,
        new PresentationContentOptions(false),
    ))
    .set(DemoName.CONCAWE_2, new DemoPresentationContent(
        'presentation.pollutingEmissions.secondGroup.demo.demo4.title',
        'presentation.pollutingEmissions.secondGroup.demo.demo4.description',
        'secondGroup-demo4',
        null,
        new PresentationContentOptions(false),
    ));

// Access information for each demonstration
export const PollutingEmissionsPresentationAccess: Map<DemoName, DemoPathAccess> = new Map()
    .set(DemoName.REALEHOMEPAGE_1, new DemoPathAccess('demo/reale-homepage-1', DEMO_ROLES.USER_ROLES))
    .set(DemoName.XDASHREALE_1, new DemoPathAccess('demo/xdash/reale-2', DEMO_ROLES.USER_ROLES))
    .set(DemoName.REALE_1, new DemoPathAccess('demo/reale-homepage-1/reale-1', DEMO_ROLES.REALE_ROLES))
    .set(DemoName.MTESHOMEPAGE_1, new DemoPathAccess('demo/mtes-homepage-1', DEMO_ROLES.MTES_ROLES))
    .set(DemoName.EMISSIONFACTORS, new DemoPathAccess('demo/emissionfactors-1', DEMO_ROLES.EMISSIONFACTORS_ROLES))
    .set(DemoName.CONCAWE_1, new DemoPathAccess('demo/concawe-1', DEMO_ROLES.CONCAWE_ROLES))
    .set(DemoName.CONCAWE_2, new DemoPathAccess('demo/concawe-2', DEMO_ROLES.CONCAWE_ROLES));
